import { styled } from '@mui/material/styles'
import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'
import { WbsItemStatusChip } from '../WbsItemStatusChip'

// 本文に混ざるインライン要素として行の中央に揃える。WbsItemStatusChip 自体は inline-flex の
// span だが、既定のベースライン揃えではチップの下端が文字のベースラインに乗り、行に対して
// 沈んで見えるため。左右の余白は、チップ内側の padding では前後の文字との間隔にならないので
// ここで付ける。
const InlineWrapper = styled('span')({
  display: 'inline-flex',
  verticalAlign: 'middle',
  margin: '0 2px',
})

export type WbsItemStatusLinkChipProps = {
  status: WbsItemStatus
}

/**
 * 応答本文の Markdown リンク `[Done](status:DONE)` をチップ表示に差し替えるコンポーネント。
 *
 * WbsItemLinkChip と違い、表示に必要な情報は href に含まれるステータス値だけで完結するため
 * API 取得もキャッシュも要らない。ラベル・配色は WbsItemStatusChip（配色の単一ソースは
 * features/WbsItemStatusChip の getOptionStyles）にそのまま任せ、AGグリッドやカンバンで
 * 見えているステータスと同じ見た目にする。
 *
 * 遷移先を持たないため a 要素にはしない（クリックしても何も起きないリンクを見せない）。
 * ホバーカードも付けない。ステータスはそれ自体が完結した値で、追加で見せる情報が無い。
 */
export const WbsItemStatusLinkChip = ({
  status,
}: WbsItemStatusLinkChipProps) => (
  <InlineWrapper>
    <WbsItemStatusChip status={status} fitContent={true} />
  </InlineWrapper>
)
